export const MUSIC_AUDIENCE_CATALOG = [
  {
    category: 'Music Discovery',
    items: [
      'Music Discovery',
      'New Music',
      'New Releases',
      'Music Streaming',
      'Music Fans',
      'Emerging Artists',
      'Song Discovery',
      'Music Recommendations',
      'Playlists',
    ],
  },
  {
    category: 'Streaming & Platforms',
    items: [
      'Spotify',
      'Apple Music',
      'YouTube Music',
      'SoundCloud',
      'Beatport',
      'Music Streaming Services',
    ],
  },
  {
    category: 'Electronic & Dance',
    items: [
      'Electronic Music',
      'EDM',
      'Dance Music',
      'House Music',
      'Deep House',
      'Tech House',
      'Afro House',
      'Progressive House',
      'Tropical House',
      'Commercial House',
      'Future House',
      'Bass House',
      'Slap House',
      'Big Room',
      'Drum & Bass',
      'Trance',
      'Dubstep',
    ],
  },
  {
    category: 'Afro, Latin & Global',
    items: [
      'Afrobeats',
      'Amapiano',
      'Afro Pop',
      'Dancehall',
      'Reggaeton',
      'Latin Music',
      'Latin Pop',
      'Global Music',
      'World Music',
    ],
  },
  {
    category: 'Pop, Urban & Contemporary',
    items: [
      'Pop Music',
      'Indie Pop',
      'Hip-Hop',
      'Rap',
      'Trap',
      'R&B',
      'Soul Music',
      'Contemporary R&B',
      'Urban Music',
    ],
  },
  {
    category: 'Music Culture',
    items: [
      'DJs',
      'DJing',
      'Music Festivals',
      'Concerts',
      'Live Music',
      'Nightlife',
      'Clubbing',
      'Dance',
      'Music Events',
      'Music Culture',
    ],
  },
  {
    category: 'Production & DJ',
    items: [
      'Music Production',
      'Electronic Music Production',
      'DJ Equipment',
      'DJ Controllers',
      'DJ Mixers',
      'Synthesizers',
      'Drum Machines',
      'Ableton Live',
      'FL Studio',
      'Logic Pro',
      'Native Instruments',
      'Pioneer DJ',
    ],
  },
];

export const INTEREST_RECOMMENDATIONS = {
  spotify_listeners: [
    'Music Discovery',
    'New Music',
    'Music Streaming',
    'Music Fans',
    'Spotify',
    'Song Discovery',
  ],
  playlist_saves: [
    'Playlists',
    'Music Discovery',
    'Music Streaming',
    'Spotify',
    'Music Fans',
  ],
  instagram_followers: [
    'Music Fans',
    'New Music',
    'Music Discovery',
    'Music Culture',
    'Live Music',
  ],
};
